import { z } from 'zod';

export const CharacterSchema = z.object({
  id: z.number().optional(),
  char_uuid: z.string(),
  title: z.string(),
  name: z.string().default('Anon'),
  description: z.string(),
  persona: z.string(),
  model_instructions: z.string(),
  scenario: z.string(),
  gender: z.string(),
  first_message: z.array(z.string()),
  creator: z.string(),
  tags: z.array(z.string()).default([]),
  profile_image: z.string(),
  chat_messages_count: z.number().optional(),
  is_public: z.boolean(),
  is_nsfw: z.boolean().optional(),
  is_owner: z.boolean().optional(),
  is_details_private: z.boolean().optional(),
  is_banned: z.boolean().optional(),
  isLoading: z.boolean().optional(),
  creator_uuid: z.string(),
  alternation_first: z.number().optional(),
  lorebook: z.string(),
  attribute: z.string().optional(),
  creator_notes: z.string().optional(),
  gallery: z.array(z.string()).default([]),
  profileImageFile: z.any().nullable().optional(),
  message_example: z.string(),
});

export const ApiResponseSchema = z.object({
  error: z.any().optional(),
  message: z.string().optional(),
  character_uuid: z.string().optional(),
  chat: z
    .object({
      chat_uuid: z.string(),
    })
    .optional(),
});

export const CharacterPayloadSchema = z.object({
  char_uuid: z.string(),
  title: z.string(),
  name: z.string().default('Anon'),
  description: z.string(),
  persona: z.string(),
  model_instructions: z.string(),
  scenario: z.string(),
  gender: z.string(),
  message_example: z.string(),
  first_message: z.array(z.string()),
  creator: z.string(),
  tags: z.array(z.string()).default([]),
  profile_image: z.string(),
  is_public: z.boolean(),
  is_nsfw: z.boolean().optional(),
  is_owner: z.boolean().optional(),
  is_details_private: z.boolean().optional(),
  is_banned: z.boolean().optional(),
  creator_uuid: z.string(),
  lorebook: z.string(),
  attribute: z.string().optional(),
  creator_notes: z.string().optional(),
  gallery: z.array(z.string()).default([]),
  profileImageFile: z.any().nullable().optional(),
});

export const CharacterSimpleSchema = z.object({
  char_uuid: z.string(),
  title: z.string(),
  name: z.string().default('Anon'),
  description: z.string(),
  persona: z.string(),
  model_instructions: z.string(),
  first_message: z.array(z.string()),
  message_example: z.string(),
  scenario: z.string(),
  gender: z.string(),
  creator: z.string(),
  creator_uuid: z.string(),
  tags: z.array(z.string()).default([]),
  profile_image: z.string(),
  chat_messages_count: z.number().optional(),
  is_public: z.boolean(),
  is_nsfw: z.boolean().optional(),
  lorebook: z.string(),
  attribute: z.string(),
  creator_notes: z.string().optional(),
  gallery: z.array(z.string()).default([]).optional(),
});

export type Character = z.infer<typeof CharacterSchema>;
export type ApiResponse = z.infer<typeof ApiResponseSchema>;
export type CharacterPayload = z.infer<typeof CharacterPayloadSchema>;
export type CharacterSimple = z.infer<typeof CharacterSimpleSchema>;